import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useFeatureFlag } from '@americanexpress/one-experiments';
import {
  getActiveLocaleSelector,
  getIsLoggedInSelector,
  getTenancySelector,
} from '@americanexpress/travel-selectors';
import { Button } from '@americanexpress/dls-react';
import { IconSearch } from '@americanexpress/dls-icons';
import { MODULE_NAME } from '../../constants/packagesConstants';
import { onSubmitThunk } from '../../thunks/onSubmitThunk';
import packageContext from '../../context/packageContext';
import { getIsSearchSubmitting } from '../../selectors/searchSelectors';

const SearchButton = () => {
  const {
    state: { moduleWrapperRef },
  } = React.useContext(packageContext);

  const { formatMessage } = useIntl();
  const { enabled, properties } = useFeatureFlag({
    featureFlagName: 'prebooking_forced_login_PACKAGES',
  });
  const [isHydrated, setIsHydrated] = useState(false);
  useEffect(() => {
    setIsHydrated(true);
  }, []);
  const dispatch = useDispatch();
  const isSearchSubmitting = useSelector(getIsSearchSubmitting);
  const isLoggedIn = useSelector(getIsLoggedInSelector);
  const tenancy = useSelector(getTenancySelector);
  const locale = useSelector(getActiveLocaleSelector);
  const forcedLoginLocales = properties?.[tenancy]?.toLowerCase() || '';
  const isForcedLoginFeatureFlagEnabled = enabled
    && forcedLoginLocales.includes(locale.toLowerCase());

  const { properties: cardModalProperties, enabled: cardModalEnabled } = useFeatureFlag({
    featureFlagName: 'prebooking_horizons_card_selection_modal',
  });

  const isCardModalEnabled = cardModalEnabled
    && cardModalProperties?.[tenancy]?.includes(locale);

  const horizonsConfig = {
    isForcedLoginFeatureFlagEnabled,
    isCardModalEnabled,
  };

  const handleSearch = () => {
    dispatch(onSubmitThunk(horizonsConfig));

    if (global?.BROWSER && moduleWrapperRef?.current !== null) {
      // This isn't the best solution as header height varies between mobile and desktop but this
      // is as close as good until we figure out a better way to work out the header height
      const globalHeaderDomHeight = 110;
      const top = Number(moduleWrapperRef?.current?.getBoundingClientRect().top)
        + window.scrollY - globalHeaderDomHeight;

      window.scrollTo({
        top,
        behavior: 'smooth',
      });
    }
  };

  const btnAriaLabel = !isLoggedIn
  && isForcedLoginFeatureFlagEnabled
    ? 'ariaLabelForcedLogin'
    : 'ariaLabel';

  return (
    <Button
      aria-label={formatMessage({ id: `searchButton.${btnAriaLabel}` })}
      onClick={isSearchSubmitting ? null : handleSearch}
      isLoading={isSearchSubmitting || !isHydrated}
      element="searchPackagesSubmit"
      id={`${MODULE_NAME}_searchButton`}
      className="pad-0 fluid"
      variant="primary"
    >
      <IconSearch
        aria-hidden={true}
        className="hidden-sm-down"
        size="md"
      />
      <span className="hidden-md-up">{formatMessage({ id: 'search' })}</span>
    </Button>
  );
};

export default SearchButton;
